import React, { ReactNode, useLayoutEffect } from 'react'
import './App.css'
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes, useLocation, useParams } from 'react-router-dom'
import { EMenu } from './components/screens/tracking/type'
import { NavbarTemplate } from './components/templates/NavbarTemplate'
import { MenuTemplate } from './components/templates/MenuTemplate'
import { SearchScreen } from './components/screens/search/SearchScreen'
import { TrackingScreen } from './components/screens/tracking/TrackingScreen'
import { ReturnRequestScreen } from './components/screens/reqReturn/ReturnRequestScreen'
import { PickupLocationScreen } from './components/screens/pickupLocation/PickupLocationScreen'
import { ReturnPlace } from './components/screens/placeReturn/ReturnPlace'
import { ExchangePlace } from './components/screens/placeExchange/ExchangePlace'
import { EntranceInfoScreen } from './components/screens/entranceInfo/EntranceInfoScreen'
import { debounce } from './common/fns'
import { TRACKING_URL, TRACKING_URL_PREV } from './common/consts.common'
import blackList from './datas/blackList.json'

declare global {
  interface Window {
    Cypress: any
    initialState: any
    install: any
    installed: boolean
  }
}

if (process.env.NODE_ENV === 'production') {
  console.log = function no_console() {
  }
}

const blackListSet = new Set(blackList)

const ScrollTopWrapper = ({ children }: { children: ReactNode }) => {
  const location = useLocation()

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    document.body.scrollTop = 0;
  }, [location.pathname])

  return children
}

const TrackingRouteGuard = () => {
  const { tracking } = useParams()

  if (tracking && blackListSet.has(tracking)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}

function App() {
  useLayoutEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    const handleResize = debounce(appHeight)

    appHeight()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Router>
      <ScrollTopWrapper>
        <Routes>
          <Route path="/" element={<NavbarTemplate/>}>
            <Route path="/" element={<SearchScreen/>}/>
            <Route path={TRACKING_URL} element={<SearchScreen/>}/>
            <Route path={TRACKING_URL + ':tracking/'}>
              <Route index element={<SearchScreen/>}/>
              <Route element={<MenuTemplate />}>
                <Route path={'detail'} element={<TrackingScreen/>}/>
                <Route path={'trk'} element={<TrackingScreen/>}/>
                <Route path={EMenu.reqReturn} element={<ReturnRequestScreen/>}/>
                <Route path={EMenu.return} element={<ReturnPlace/>}/>
                <Route path={EMenu.info} element={<PickupLocationScreen/>}/>
                <Route path={EMenu.exchange} element={<ExchangePlace/>}/>
                <Route path={EMenu.entrance} element={<EntranceInfoScreen/>}/>
              </Route>
            </Route>
            <Route path={TRACKING_URL_PREV + ':tracking/'} element={<TrackingRouteGuard />}>
              <Route index element={<SearchScreen/>}/>
              <Route element={<MenuTemplate />}>
                <Route path={'tracking'} element={<TrackingScreen/>}/>
                <Route path={EMenu.reqReturn} element={<ReturnRequestScreen/>}/>
                <Route path={EMenu.return} element={<ReturnPlace/>}/>
                <Route path={EMenu.info} element={<PickupLocationScreen/>}/>
                <Route path={EMenu.exchange} element={<ExchangePlace/>}/>
                <Route path={EMenu.entrance} element={<EntranceInfoScreen/>}/>
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </ScrollTopWrapper>
    </Router>
  )
}

export default App
